//Auto-generated, please do not edit.

export default
{
    "common": {
        "tax": "Tax",
        "total": "Total",
        "summary": "Summary",
        "date": "Date",
        "restart": "Restart",
        "restore": "Restore",
        "table": {
            "no-data": "No data"
        },
        "search": "Search",
        "today": "Today",
        "to": "to",
        "yesterday": "Yesterday",
        "apply": "Apply",
        "cancel": "Cancel",
        "all": "All",
        "yes": "Yes",
        "ok": "Ok",
        "close": "Close",
        "logs": "Logs",
        "no": "No",
        "save": "Save",
        "delete": "Delete",
        "edit": "Edit",
        "verify": "Verify",
        "try-again": "Try again",
        "time": "Time",
        "buckets": {
            "months": "months",
            "weeks": "weeks",
            "days": "days"
        },
        "showing": "Showing _START_ to _END_ of _TOTAL_ entries",
        "filtered": "(filtered from _MAX_ total entries)",
        "show": "Show",
        "items-per-page": "Items per page",
        "back": "Back",
        "optional": "Optional",
        "emtpy-view-title": "...hmm, seems empty here",
        "emtpy-view-subtitle": "No data found",
        "drawer": {
            "next-step": "Next step",
            "previous-step": "Previous step"
        },
        "diff-helper": {
            "changes": "You made {0} changes.",
            "keep": "Do you want to keep them?"
        },
        "save-changes": "Save changes",
        "discard-changes": "Discard",
        "confirm": "Confirm",
        "remove": "Remove",
        "terminate": "Terminate",
        "proceed": "Proceed",
        "and": "and",
        "error": "Error",
        "enter-email-addresses": "Enter Email Addresses",
        "invalid-email-address": "\"{0}\" is not a valid email address",
        "email-example": "(e.g. john@doe.mail)",
        "no-email-addresses": "No addresses have been specified",
        "all-time": "All time",
        "time-period-select": {
            "custom-range": "Custom Range",
            "last-n": "In the Last",
            "since": "Since",
            "on": "On",
            "range": "In Between"
        },
        "time-period-name": {
            "since": "since {0}",
            "on": "on {0}"
        },
        "apply-range": "Apply Range",
        "range-length-limit": "Selected range cannot be longer than {0}.",
        "no-info": "No info",
        "success": "Success",
        "please-wait": "Please wait...",
        "another-session-detected": "Your session has ended because you logged in from a different location.",
        "loading": "Loading"
    },
    "taskmanager": {
        "last-7days": "Last 7 days",
        "last-30days": "Last 30 days",
        "last-60days": "Last 60 days"
    },
    "events": {
        "general": {
            "cancel": "Cancel",
            "confirm": "Confirm"
        }
    },
    "export": {
        "export-as": "Export as",
        "export": "Export",
        "export-all-columns": "Export all columns",
        "export-columns-selected-count": "{0}/{1} selected"
    },
    "management-applications": {
        "plugins": {
            "title": "App settings",
            "smth": "Something went wrong"
        }
    },
    "management-users": {
        "create": "Create",
        "created": "Created"
    },
    "user-settings": {
        "change-password": "Change password"
    },
    "mycountly": {
        "errors": {
            "please-dont-use-url-in-company-name": "Please don't use URL in company name",
            "an-error-occurred": "An error has occurred",
            "could-not-activate-verification": "Could not activate verification.",
            "incorrect_code": "Invalid verification code",
            "invalid-invitation-token": "Invalid or expired invitation token",
            "missing-password-reset-code": "Password reset code missing",
            "invalid-password-reset-code": "Invalid password reset code",
            "something-went-wrong": "Something went wrong",
            "file-is-too-big": "File is too big. Please try again with a smaller file.",
            "checkboxes-required": "You must agree to the terms and conditions and privacy policy",
            "please-check-fields": "Please check fields:"
        },
        "signup": {
            "create-an-account": "Create your Flex account",
            "complete-setup": "Almost there!",
            "complete-setup-btn": "Complete setup",
            "complete-setup-description": "Create your account to manage your Countly server.",
            "full-name": "Full name",
            "first-name": "First Name",
            "last-name": "Last Name",
            "email": "Email",
            "terms-conditions": "I agree to the Terms and Conditions",
            "privacy-policy": "I agree to the Privacy Policy",
            "password": "Password",
            "confirm-password": "Confirm Password",
            "password-requirements": "Password Requirements",
            "create-account": "Get started",
            "or": "or",
            "verification": "Verification",
            "opt-for-enterprise-1": "Companies of your size usually opt for",
            "opt-for-enterprise-2": "Countly Enterprise.",
            "placeholder": {
                "enter-your-name": "Jane Doe",
                "enter-your-first-name": "Enter your first name",
                "enter-your-last-name": "Enter your last name",
                "enter-your-email": "you@company.com",
                "enter-your-password": "Enter your password",
                "confirm-your-password": "Confirm your password",
                "enter-your-company-name": "Enter your workspace name",
                "company-size-subtitle": "This value has nothing to do with pricing; it is to help us get to know your company better.",
                "enter-your-company-size": "Select your organization size",
                "enter-your-designation": "Select your role"
            },
            "we-almost-there": "We are almost there!",
            "please-enter-verification": "Please enter the verification code that was sent to your email address",
            "next": "Next",
            "your-company": "Your Workspace",
            "just-need-your": "Finally, please tell us a bit about your workspace",
            "lets-go": "Let's create your Countly server",
            "look-around": "I'll do it later, let me look around",
            "company-name": "Workspace name",
            "new-password": "New Password",
            "create-your-new-account-password": "Create your new account password below",
            "company-size": "Organization size",
            "designation": "Role",
            "email-address": "Email Address",
            "try-different-email-address": "Please try different email address",
            "send-email": "Send Email",
            "back-to-login": "Back to login",
            "password-reset-email-sent": "Password Reset Email Sent",
            "unlock-email-sent": "Account Unlock Email Sent",
            "an-email-has-been-sent": "An email has been sent to your email address, {0}.",
            "follow-directions-in-the-email": "Follow the directions in the email to reset your password.",
            "follow-directions-in-the-email-to-unlock": "Follow the directions in the email to unlock your account.",
            "forgot-password": "Forgot Password",
            "unlock-account": "Request account unlock",
            "please-enter-your-account-email": "Please enter the email address associated with your account to",
            "receive-instructions-on": "receive instructions on resetting your password",
            "receive-instructions-on-unlocking-account": "receive instructions on unlocking your account",
            "already-have-an-account": "Already have an account?",
            "reset-my-password": "Reset my password",
            "resend-verification-code": "Resend verification code",
            "skip-verification": "Skip verification step",
            "invitation-accepted": "Invitation accepted"
        },
        "marketing": {
            "join-our-self-service": "Join our self-service Countly experience",
            "trusted-by-1000-plus": "Trusted by 1000+ businesses worldwide",
            "a-host-environment": "A hosted environment that provides self-service Countly experience to customers. Fast, Powerful, Something."
        },
        "signin": {
            "login": "Sign in to your Flex account",
            "create-an-account": "Create an account",
            "request-unlock-account": "Unlock Account",
            "email": "Email",
            "placeholder": {
                "email": "you@company.com"
            },
            "sign-in": "Sign in"
        },
        "validations": {
            "required": "This field is required.",
            "match": "Values not match",
            "domain": "Please enter a valid domain",
            "digits": "Please enter correct digits.",
            "email": "Please enter a valid email address.",
            "min": "Too short.",
            "at-least-8-characters": "At least 8 characters long",
            "max-32-characters": "Max 32 characters long",
            "one_uppercase": "At least one uppercase letter",
            "one_lowercase": "At least one lowercase letter",
            "one_number": "At least one number",
            "one_special": "At least one special character",
            "max": "Too long.",
            "confirmed": "Passwords do not match.",
            "verify_password": "Password should contain at least 1 uppercase, 1 lowercase, 1 number and 1 special character.",
            "noHtml": "HTML tags are not allowed."
        },
        "responses": {
            "same-password-error": "Your new password must be different from old",
            "email-sent-if-account-exists": "A password reset email has been sent if such an account exists",
            "wrong-password": "Wrong password",
            "user-not-exists": "User does not exist",
            "email-sent": "Email sent",
            "invalid-reset-token": "Invalid password reset token",
            "password-reset-successfully": "Your password was reset successfully",
            "email-sent-if-account-exist": "E-mail sent if account exist.",
            "signin-success": "Sign in successful."
        },
        "dashboard": {
            "verification-message": "You have not verified your email address yet",
            "verify-now": "Verify now",
            "profile": {
                "settings": "Profile Settings",
                "photo": "Photo",
                "current-password": "Current Password",
                "new-password": "New Password",
                "enter-your-current-password": "Enter your current password",
                "enter-your-new-password": "Enter your new password",
                "confirm-your-new-password": "Confirm your new password"
            },
            "company": {
                "logo": "Logo"
            },
            "account": {
                "settings": "Account Settings"
            },
            "data": {
                "settings": "Data settings",
                "danger-zone": "Danger zone",
                "danger-zone-user-description": "Deleting your account permanently removes your profile and personal data. Any workspace where you are the only member will also be deleted, together with all of its projects and servers. If such a workspace still has servers with an active paid subscription, you must delete those servers first. This action is irreversible, so proceed with caution.",
                "remove-my-data-failed": "Data remove process failed. Try again later.",
                "remove-my-user-data": "Remove my user data",
                "remove-my-workspace-data": "Remove my workspace data",
                "confirmation-required": "We've sent a verification code to you",
                "remove-my-data-desc": "Please enter the verification code we sent to your email address, and remember this process will remove data from Countly servers irreversibly.",
                "resend-code": "Resend code",
                "invalid-verification-code": "Verification code should be 5 digits",
                "verification-code-already-sent": "Verification code already sent, please wait 2 minutes to resend new one.",
                "remove-approval-placeholder": "Enter your password to confirm",
                "danger-zone-workspace-description": "Deleting this workspace permanently removes all of its projects, servers and data for every member. Workspaces that still have servers with an active paid subscription cannot be deleted — delete those servers first. This action is irreversible, so proceed with caution."
            },
            "authentication": {
                "settings": "Authentication Settings"
            },
            "management": {
                "title": "Management",
                "company": "Workspace",
                "team": "Team",
                "invite-team-member": "Invite team member",
                "invite-sent": "Invitation on its way",
                "send-invitation": "Send invitation",
                "name": "Name",
                "email": "Email",
                "role": "User role",
                "status": "Status",
                "delete": "Delete",
                "last-login": "Last login",
                "there-are-some-failed-invites": "There are some failed invites",
                "some-processes-are-failed": "Some processes are failed",
                "enable-2fa-with-authenticator": "Enable 2FA using an authenticator app",
                "disable-2fa-with-authenticator": "Disable 2FA",
                "2fa-title": "Two-Factor Authentication",
                "2fa-description": "Two-Factor Authentication is a powerful security feature that enables you to add an extra layer of protection to your account",
                "6-digit-code": "6-digit code",
                "enter-6-digit-code": "Enter the 6-digit code",
                "generate-new-qr": "Generate New QR Code",
                "enable-2fa": "Enable 2FA",
                "2fa-step-1-title": "Step 1: Scan the QR code",
                "2fa-step-2-title": "Step 2: Enter the code",
                "2fa-step-1-desc": "Use your authenticator app to scan the below QR code",
                "2fa-disable-title": "Enter your code",
                "2fa-generic-title": "Disable Two-Factor Authentication",
                "2fa-generic-desc": "Enter the 2FA code in your authenticator app to continue",
                "verification-required": "Verification Required",
                "never-logged-in": "Never logged in",
                "project": "Project",
                "project-name": "Project name",
                "billing-name": "Payment method name",
                "create-project": "Create project",
                "create-billing": "Update Billing Info",
                "create-new-project": "Create New Project",
                "enter-project-name": "Enter project name",
                "enter-billing-name": "Enter payment method name",
                "select-deployments": "Select servers",
                "select-project-admins": "Select project admins",
                "select-project-users": "Select project users",
                "admins": "Admins",
                "users": "Users",
                "deployment-tasks": "Server Tasks",
                "deployments": "Servers",
                "created-on": "Created on",
                "payment-method-status": "status",
                "edit-project": "Edit project",
                "update-billing-info": "Update Billing Info",
                "project-created": "Project created",
                "payment-method-created": "Payment method created",
                "project-updated": "Project updated",
                "payment-method-updated": "Payment method updated",
                "enter-team-member-email": "Enter the email address of the team member",
                "select-team-member-role": "Select the role of the team member",
                "2fa-step-2-desc": "Enter the 6-digit code from your authenticator app",
                "projects": "Projects",
                "billings": "Billing",
                "billings-history": "Billing History",
                "billings-details": "Billing Details for",
                "billings-period": "Billing Period",
                "billings-renew": "Renews:",
                "billings-per-month": "per month",
                "billings-per-year": "per year",
                "billings-current-usage": "Current Usage",
                "billings-within-tier-limit": "within tier limit",
                "billings-exceeded-tier-limit": "exceeded tier limit",
                "other-views": "Other management views",
                "other-management-views": "Other management views",
                "invite": {
                    "another-team-member": "Add new invitation"
                },
                "jobs": {
                    "id": "ID",
                    "url": "URL",
                    "output": "Output",
                    "runat": "Run at",
                    "updatedat": "Updated At",
                    "createdat": "Created At"
                },
                "companies-companies": "Companies",
                "companies-owner-name-id": "Owner name - ID",
                "companies-name": "Company name",
                "companies-logo": "Logo",
                "companies-updated": "Updated",
                "companies-created": "Created",
                "logs-id": "ID",
                "logs-user-id": "USER ID",
                "logs-model": "Model",
                "logs-event-type": "EVENT TYPE",
                "logs-reference": "REFERENCE ID",
                "logs-before": "BEFORE",
                "logs-after": "AFTER",
                "logs-type": "Type",
                "logs-content": "Content",
                "logs-deployment": "Deployment",
                "logs-from": "From",
                "logs-time-stamp": "Time stamp",
                "logs-messaged": "Messaged At",
                "logs-created": "Created",
                "logs-updated": "Updated",
                "jobs-type": "Type",
                "jobs-content": "Content",
                "jobs-deployment": "Deployment",
                "jobs-from": "From",
                "jobs-time-stamp": "Time stamp",
                "jobs-messaged": "Messaged At",
                "jobs-created": "Created",
                "jobs-updated": "Updated",
                "users-last-active": "Last login",
                "deploymentTasks-id": "ID",
                "deploymentTasks-deployment-id": "Deployment ID",
                "deploymentTasks-status": "status",
                "deploymentTasks-type": "Type",
                "deploymentTasks-assignee-id": "Assignee ID",
                "deployment-task-details-title": "Deployment Task Details",
                "deployment-task-details-id": "Task ID:",
                "deployment-task-details-deploymentid": "Deployment ID:",
                "deployment-task-details-status": "Status:",
                "deployment-task-details-type": "Type:",
                "deployment-task-details-assignee-id": "Assignee ID:",
                "deployment-task-confirmation-message": "Status is being changed to",
                "deployment-details-name": "Name"
            },
            "dashboard": {
                "title": "Dashboard",
                "view-all-servers": "View all servers",
                "all-servers": "All servers",
                "my-server": "My server",
                "my-servers": "My servers",
                "server-count": "{count} server | {count} servers"
            },
            "deployments": {
                "title": "Servers",
                "learn-sdk": "Take a look at Countly SDKs while you wait",
                "retention-change-not-allowed": "You can not downgrade retention period of existing server",
                "server-and-domain": "Server and Domain",
                "features-and-add-ons": "Features and Add-ons",
                "data-information": "Data Information",
                "dns-configuration-title": "DNS Configuration",
                "dns-configuration-description": "Configure a DNS A record for your domain to point to the below IP address to finalize the setup. This may take a while depending on your DNS provider.",
                "ip-address": "IP Address",
                "enter-deployment-name": "Enter your preferred server name",
                "remove-confirm-title": "Are you sure you want to terminate this server?",
                "restart-confirm-title": "Are you sure you want to restart this server?",
                "restore-confirm-title": "Are you sure you want to restore this backup?",
                "remove-confirm-description": "Placeholder message for server terminate process.",
                "insert-name-restart-deployment-dialog": "below to confirm the restart",
                "insert-name-restore-backup-dialog": "below to confirm the restore",
                "insert-name-remove-deployment-dialog": "below to confirm the termination",
                "remove-confirm-approve": "Yes, terminate",
                "restart-confirm-approve": "Yes, restart",
                "restore-confirm-approve": "Yes, restore",
                "restoration-started": "Restoration initiated",
                "restoration-failed": "Restoration failed",
                "mau-description": "Monthly Active Users/mo",
                "started": "Server creation process initiated. We’ll email you in a few minutes when your server is ready.",
                "update": {
                    "started": "Server update process initiated"
                },
                "no-project": "You can not create a server before creating a project. Please create the project first.",
                "name": "Server Name",
                "domain": "Domain",
                "utilization": "Utilization",
                "deployment-information": "Server Information",
                "create-deployment": "Let's create your Countly server",
                "create-server-submit": "Create server",
                "new-deployment": "New Countly server",
                "review-deployment": "Review server",
                "manage-deployments": "Manage servers",
                "domain-address": "Domain address",
                "domain-ssl-certificate": "Domain & SSL Certificate",
                "custom-domain-and-certificate": "Custom domain and SSL certificate",
                "provider": "Provider",
                "domain-address-description": "Configure your own domain and SSL for your Countly server",
                "locations": "Server Region",
                "providers": "Cloud Provider",
                "providers-description": "Choose the cloud provider you prefer.",
                "default-domain-address": "Default domain",
                "sizes-description": "Choose the size of your server. We'll notify you when your server is close to its full capacity.",
                "location": "Location",
                "size": "Size",
                "sizes": "Sizes",
                "data-retention": "Data retention",
                "features-description": "A descriptive text about features.",
                "created-date": "Created on",
                "out-of": "out of",
                "selected": "selected",
                "capabilities": "Additional Capabilities",
                "capabilities-description": "A descriptive text about features.",
                "retention": "Data Retention",
                "retention-help": "This is the data retention for granular data that feeds features such as Drill, Funnels, Cohorts and Formulas. Aggregated data will be stored indefinitely unless you choose to clear it from your Countly server's app management.",
                "retention-description": "Select your preferred retention period for granular data",
                "data-backups": "Data Backups",
                "data-backups-help": "You can choose a backup from your server details page to restore your Countly server data to a past state.",
                "data-backups-description": "Choose your backup frequency for a safety net against unforeseen events",
                "unlock-countly-user": "Unlock Dashboard User",
                "unlock-user": "Unlock dashboard user",
                "user-unlocked": "Dashboard user successfully unlocked",
                "user-unlock-failed": "Dashboard user unlock failed",
                "type-deployment-name": "Enter the server name",
                "unlock-user-email": "Email address of the dashboard user",
                "review": "Review",
                "public-key": "Public key",
                "private-key": "Private key",
                "configure-domain-and-ssl": "Configure domain",
                "verify": "Verify",
                "update-deployment": "Update server",
                "update-deployment-settings": "Update Server",
                "upgrade-server": "Upgrade Server",
                "no-ip-addr": "Unable to retrieve IP address information",
                "certificate": "Certificate",
                "skip-to-verification": "Skip to verification",
                "free-forever": "FREE FOREVER",
                "off-text": "(16% off)",
                "free": "Free",
                "monthly-active-users": "monthly active users",
                "monthly-active-users-short": "MAU",
                "need-more-than": "Do you need more than",
                "up-to": "Up to",
                "tier": "Tier",
                "tier-help": "The tier selection represents the maximum monthly active users your Countly server can handle.",
                "tier-description": "Monthly Active Users (MAU) you are expecting to track using this Countly server.",
                "need-more": "Need more?",
                "the-basics": "The Basics",
                "features": "Features",
                "extras": "Extras",
                "review-launch": "Review",
                "contact-sales": "Contact sales",
                "free-during-alpha": "FREE DURING ALPHA",
                "region": "Region",
                "included-core-features": "Included Core Features",
                "included-core-features-help": "Your Countly server will have most of these core features available. Some of them may only available with Tier 1 and above.",
                "included-core-features-description": "Check our core features already included to your plan",
                "server-region": "Server Region",
                "server-region-help": "Your Countly server will be running in this region.",
                "backups": "Server Backups",
                "backup-name": "Server Backup",
                "tooltips": {
                    "data-retention": "Data retention"
                },
                "description": "Server description",
                "core-features": "Core features",
                "no-mau-info": "No MAU info",
                "domain-and-ssl": "Domain",
                "domain-and-ssl-description": "Customize the domain and the SSL certificate of your Countly server to make it truly yours",
                "domain-and-ssl-help": "By default, your Countly server will have a *.flex.countly.com domain and a Let's Encrypt SSL certificate for HTTPs connections. Choose \"Use custom domain and SSL certificate\" to use a custom domain and SSL certificate.",
                "enter-your-domain": "Enter your domain",
                "enter-private-key": "Enter your private key",
                "enter-certificate": "Enter your certificate",
                "ssl-already-set": "You have already set up an SSL certificate configuration for this domain",
                "update-configuration": "Update configuration",
                "review-and-verify": "Review and Verify",
                "default-ssl": "Default SSL",
                "default-ssl-description": "Use a Let's Encrypt SSL certificate for your server",
                "custom-ssl": "Custom SSL",
                "custom-ssl-description": "Use your own SSL certificate for your server",
                "your-custom-domain": "You can set your custom domain after creating your server",
                "deployment-name": "Server name",
                "plans": "Plans",
                "plans-description": "Pick a server size tailored to your monthly active users",
                "per-month": "per month",
                "add-ons": "Feature Add-ons",
                "add-ons-help": "Extra features you can equip your Countly server with.",
                "add-ons-description": "Select feature add-ons to supercharge your server",
                "included": "Included",
                "coming-soon": "Coming soon",
                "in-this-plan": "in this plan",
                "suggested-features": "Feature add-ons for your Countly server",
                "see-all": "See all",
                "not-available-help": "You should return to the plan selection step and choose a higher tier to make this feature available",
                "server-creation": {
                    "no-region-change-for-free": "Changing regions isn't available on free plans.",
                    "region-unavailable": "This region is not available for your tier."
                },
                "not-available": "Not available",
                "available-for": "Available for",
                "others": "others",
                "get-info": "Get info",
                "get-now": "Get now",
                "can-not-update-on-free-tier": "You have the option to modify your server region for Tier 1 and above.",
                "no-feature-selected": "This Countly server doesn't have any feature add-ons enabled",
                "no-region-change-for-free": "You can not change the region of a free server",
                "show-events": "Show server events",
                "deployment-events": "Event Log",
                "can-not-downgrade": "You can not downgrade your server to a lower tier",
                "deployment-events-description": "The event log shows all the events that happen throughout the lifecycle of your Countly server.",
                "proceed-to-payment": "Proceed to payment",
                "launch-server": "Launch server",
                "update-server": "Update server",
                "no-credit-card": "No credit card info required",
                "price-calculation-failed": "Something went wrong while calculating price",
                "cost-impact": "Cost impact",
                "scheduled-cancel": "Your server will be terminated on {0} based upon your request.",
                "no-communication": "Not checked in the last 30 mins",
                "health-check": "Health Check",
                "health-check-title": "Check health of your Countly Server",
                "health-check-description": "This will check the health of your server and update the status accordingly",
                "health-check-ok": "Your server is OK",
                "health-check-failed": "Your server is not OK, contact support.",
                "last-data-received": "LDR",
                "marked-zombie": "Zombie",
                "version": "Version",
                "exceeded-label": "Exceeded",
                "exceeded-detectedAt": "detected at",
                "exceeded-lockedAt": "locked at",
                "exceeded-locksAt": "locks at",
                "current-period-usage": "Current period usage",
                "usage-of-tier-limit": "{mau} MAU · {percent}% of tier limit",
                "period-day-progress": "Day {day} of {total}",
                "period-resets-on": "Resets on {date}",
                "no-usage-data": "No usage data reported yet",
                "no-usage-history": "No usage history yet",
                "tier-limit-tooltip": "Exceeding your tier limit locks data collection 4 days after it is detected",
                "is-exceeded-tier-limit": "is exceeded tier limit.",
                "is-close-to-capacity": "is close to it’s full capacity.",
                "zombie-notifications": "notifications",
                "update-ip": "Update IP",
                "invalid-server-name": "Server name must contain at least 2 non-whitespace characters.",
                "cannot-configure-during-trial": "You cannot change server configuration during the trial period.",
                "cannot-upgrade-legacy-plan": "This server cannot be upgraded, please contact our support team via Intercom."
            },
            "empty-table-title": "...hmm, seems empty here",
            "page-not-found": "Page not found",
            "go-back-to-home": "Go back to home",
            "deployments-admin": {
                "name": "Name"
            },
            "projects": {
                "project-switched": "Project switched",
                "no-admin-in-project": "There are no project admins"
            },
            "deployments-information": "Server Information",
            "empty-table-description": "Get started by creating a server",
            "you-are-all-set": "👍 This server has enough MAU limit",
            "getting-started": "GETTING STARTED",
            "welcome-to-mycountly": "Welcome to Countly Flex!",
            "here-are-resources": "Some resources to get you started with ease:",
            "sdk-integration": "SDK Integration",
            "user-guidelines": "User Guides",
            "want-to-chat-with-us": "Let's help you get started",
            "book-a-meeting": "Book a 30-min call",
            "resources": {
                "title": "Quick links to help you get started"
            },
            "prelogin": {
                "i-agree-to-the": "I agree to the",
                "terms-of-service": "Terms of Service",
                "privacy-policy": "Privacy Policy"
            },
            "deployment": {
                "region": {
                    "not-available-help": "You should return the plan selection step and choose higher tier to make this region available"
                },
                "creation": {
                    "choose": {
                        "plan": {
                            "title": "Choose your Countly Flex plan",
                            "subtitle": "Let's create your very own product analytics server starting with plan selection",
                            "select": {
                                "title": "How many monthly active users you plan to have?",
                                "subtitle": "The tier selection represents the maximum monthly active users your Countly server can handle."
                            }
                        },
                        "plan-prelogin": {
                            "title": "Get started with Countly Flex",
                            "subtitle": "Set up your own analytics server in minutes. Choose a plan below, you can change or upgrade anytime."
                        },
                        "region": {
                            "title": "Choose hosting region",
                            "subtitle": "Select your region, your Countly server will be running up in this region."
                        },
                        "addons": {
                            "title": "Choose add-ons",
                            "subtitle": "Tailor your server by adding powerful add-ons to boost it even further."
                        },
                        "extras": {
                            "title": "Extras",
                            "subtitle": "Tailor your server by choosing your retention period, and adding your own custom domain."
                        }
                    },
                    "payment": {
                        "title": "Payment details",
                        "subtitle": "Complete your server creation by providing your payment details."
                    }
                },
                "billed-monthly": "Billed monthly",
                "billed-yearly": "Billed yearly",
                "monthly": "Monthly",
                "yearly": "Yearly",
                "status-comm-error": "Waiting for response",
                "status-provisioned": "Provisioned",
                "status-initializing": "Initializing",
                "status-modifying": "Modifying",
                "status-restoring": "Restoring",
                "status-restarting": "Restarting",
                "status-paused": "Paused",
                "status-running": "Running",
                "status-deleted": "Deleted",
                "status-retired": "Retired",
                "retired-dialog-title": "This server has been retired",
                "retired-dialog-message": "As part of Flex's move to a new analytics engine, the Flex Free Tier has been retired and this server is no longer active. Your data is being kept temporarily, so you still have a chance to recover it. Please contact our support team to learn about your options for restoring your data and continuing with Flex.",
                "status-initializing-error": "Initializing error",
                "status-modifying-error": "Modifying error",
                "status-restoring-error": "Restoring error",
                "status-restarting-error": "Restarting error",
                "status-pausing-error": "Pausing error",
                "status-deleting-error": "Deleting error"
            },
            "header": {
                "title": "Get Started",
                "description": "Let's create your very own product analytics server.",
                "select": "In the region you want. With the features you need.",
                "create-deployment": "Create a new Countly server"
            },
            "pastdue": {
                "update-billing": "Update billing info",
                "beginning": "We are unable to process payment for",
                "continue": "To keep using Countly Flex, update your billing info."
            },
            "payment-modal": {
                "tax-description": "Will be calculated based on your country and your VAT status on the payment",
                "success-title": "Your server is almost ready...",
                "success-title-edit": "Your server is almost ready...",
                "success-description": "We'll navigate you to your Countly server after the final adjustments, it may take a few minutes. You can take a look at our latest release notes while you wait.",
                "success-description-edit": "We'll navigate you to your Countly server after the final adjustments, it may take a few minutes. You can take a look at our latest release notes while you wait.",
                "success-cta": "Go to Flex"
            },
            "jobs": {
                "title": "Jobs"
            },
            "companies": {
                "title": "Companies"
            },
            "admin": {
                "you-are": "You are in",
                "mode": "Admin Mode",
                "go-to": "Go to Admin Panel",
                "title": "Admin",
                "exit": "Exit admin",
                "home": "Home",
                "user": "User",
                "users": "Users",
                "server": "Server",
                "servers": "Servers",
                "companies": "Workspaces",
                "subscriptions": "Subscriptions",
                "palette-placeholder": "Search users, workspaces, servers, subscriptions...",
                "palette-hint": "Type to search across users, workspaces, servers, and subscriptions.",
                "palette-empty": "No matches found",
                "palette-navigate": "Navigate",
                "palette-open": "Open",
                "palette-close": "Close",
                "home-description": "An overview of users, workspaces, servers, and subscriptions across the platform.",
                "insights": "Insights",
                "no-insights": "No insights to report right now.",
                "activity": "Recent activity",
                "no-activity": "No recent activity.",
                "activity-user-signed-up": "{name} signed up",
                "activity-company-created": "Workspace {name} was created",
                "activity-server-created": "Server {name} was created",
                "latest-users": "Latest users",
                "latest-companies": "Latest workspaces",
                "latest-servers": "Latest servers",
                "view-all": "View all",
                "fetch-failed": "Failed to fetch data",
                "total-users": "Total users",
                "total-companies": "Total workspaces",
                "subscribed-workspaces": "Subscribed workspaces",
                "stat-note-synced-users": "{n} synced from customer servers",
                "stat-note-total-registered": "{n} registered in total",
                "total-servers": "Total servers",
                "active-servers": "Active servers",
                "usage": "Usage",
                "mau-usage": "MAU usage (current period)",
                "past-months": "Past months",
                "status-active-free": "Active free",
                "status-active-paid": "Active paid",
                "status-paying": "Paying (active payment method)",
                "company-filter-all": "All workspaces",
                "company-filter-subscribed": "Subscribed",
                "filter-users": "All users",
                "active-free-owners": "Active free server owners",
                "active-paid-owners": "Active paid server owners",
                "export-csv": "Export CSV",
                "exporting": "Exporting…",
                "export-failed": "Export failed",
                "new-last-7d": "no new in the last 7 days | +1 in the last 7 days | +{count} in the last 7 days",
                "insight-new-signups-24h": "No new signups in the last 24h | 1 new signup in the last 24h | {count} new signups in the last 24h",
                "insight-new-workspaces-7d": "No new workspaces in the last 7 days | 1 new workspace in the last 7 days | {count} new workspaces in the last 7 days",
                "insight-stale-servers": "No stale servers | 1 server has not received data recently | {count} servers have not received data recently",
                "insight-scheduled-cancel": "No scheduled cancellations | 1 subscription is scheduled to cancel | {count} subscriptions are scheduled to cancel",
                "insight-trial-ending": "No trials ending soon | 1 trial is ending soon | {count} trials are ending soon",
                "users-description": "All users registered on the platform.",
                "search-users-placeholder": "Search by name or email...",
                "filter-by-role": "All roles",
                "role-admins": "Admins",
                "role-customers": "Customers",
                "role-non-countly": "Non-Countly users",
                "filters": "Filters",
                "apply-filters": "Apply",
                "name": "Name",
                "email": "Email",
                "role": "Role",
                "created": "Created",
                "verified": "Verified",
                "user-detail-description": "User profile and workspace memberships.",
                "user-not-found": "User not found",
                "workspaces": "Workspaces",
                "no-workspaces": "No workspace memberships",
                "designation": "Designation",
                "is-admin": "Admin",
                "mfa-enabled": "MFA enabled",
                "last-login": "Last login",
                "signup-via": "Signed up via",
                "registered-after": "Registered after",
                "registered-before": "Registered before",
                "last-login-after": "Last login after",
                "last-login-before": "Last login before",
                "pick-date": "Pick date",
                "companies-description": "All workspaces created on the platform.",
                "search-companies-placeholder": "Search workspaces...",
                "owner": "Owner",
                "company-detail-description": "Workspace details and member list.",
                "company-not-found": "Workspace not found",
                "members": "Members",
                "servers-description": "All Countly servers provisioned across workspaces.",
                "search-servers-placeholder": "Search servers...",
                "filter-by-company": "Filter by workspace",
                "last-data-received": "Last data received",
                "mau-percent": "MAU %",
                "dp-percent": "DP %",
                "volatile-user-hint": "Synced from a customer's Countly server",
                "company": "Workspace",
                "server-detail-description": "Server overview, domains, and recent tasks.",
                "server-not-found": "Server not found",
                "open-dashboard": "Open dashboard",
                "view-as-user": "View as user",
                "back-to-server": "Back to server",
                "mau-trend": "MAU trend",
                "domains": "Domains",
                "domain": "Domain",
                "default-domain": "Default domain",
                "custom-domain": "Custom domain",
                "not-configured": "Not configured",
                "verified-yes": "Verified",
                "pending": "Pending",
                "off": "Off",
                "recent-tasks": "Recent tasks",
                "no-tasks": "No recent tasks",
                "edit-server": "Edit",
                "edit-server-title": "Edit server",
                "server-name": "Server name",
                "status-override-hint": "Status is a raw database override — it does not start, stop, or provision the actual server.",
                "server-updated": "Server updated successfully.",
                "server-update-failed": "Server could not be updated.",
                "subscriptions-description": "All active and past subscriptions across workspaces.",
                "search-subscriptions-placeholder": "Search subscriptions...",
                "active-subscriptions": "Active subscriptions",
                "estimate": "Estimate",
                "mrr-hint": "Estimated monthly recurring revenue based on active subscriptions.",
                "mrr-note": "Excludes trials and free servers. Yearly subscriptions are normalized to a monthly amount.",
                "stat-in-trial": "In trial",
                "stat-paying-customers": "Paying customers",
                "stat-total-mrr": "Total MRR",
                "stat-avg-mrr": "Avg. MRR / customer",
                "stat-note-paid-servers": "{n} paid servers",
                "stat-note-mrr-scope": "Excludes trials and free servers",
                "stat-hint-total-users": "Workspace members plus users synced from customers' Countly servers. Signups that never created or joined a workspace are not counted.",
                "stat-hint-active-servers": "Servers in an active state (initializing, modifying, restoring, restarting, running or retired), plus servers provisioned within the last 7 days.",
                "monthly-count": "no monthly | 1 monthly | {count} monthly",
                "yearly-count": "no yearly | 1 yearly | {count} yearly",
                "plan-mix": "Plan mix",
                "no-plan-data": "No plan data available",
                "tab-all": "All",
                "tab-in-trial": "In trial",
                "tab-past-due": "Past due",
                "tab-scheduled-cancel": "Scheduled to cancel",
                "tab-trial-ending": "Trial ending",
                "filter-by-status": "Status",
                "status-non-provisioned": "All except provisioned",
                "status-all": "All statuses",
                "status-active": "Active",
                "status-provisioned": "Provisioned",
                "status-update-provisioned": "Update provisioned",
                "status-suspended": "Suspended",
                "status-archived": "Archived",
                "status-not-active": "Not active",
                "server-filter-active": "Active",
                "server-filter-all": "All (except deleted)",
                "server-filter-junk": "Junk",
                "server-filter-paused": "Paused",
                "server-filter-errored": "Errored",
                "server-filter-zombie": "Zombie",
                "server-filter-exceeded": "Limit exceeded",
                "server-filter-in_use": "In use",
                "server-filter-paid": "Paid",
                "server-filter-free": "Free",
                "filter-by-tier": "All tiers",
                "tier-mode-eq": "Exact tier",
                "tier-mode-gte": "Tier and above",
                "tier-mode-lte": "Tier and below",
                "export-communication-emails": "Export communication emails",
                "export-no-rows": "Nothing to export for the current filters",
                "monthly-payment": "Monthly",
                "trial-days-left": "{n} day left | {n} days left",
                "plan": "Plan",
                "cycle": "Cycle",
                "status": "Status",
                "trial": "Trial",
                "trial-active": "Trialing",
                "modify-configuration": "Modify configuration",
                "modify-hint": "Changes apply immediately and propagate to Paddle.",
                "select-plan": "Select a plan",
                "select-region": "Select a region",
                "no-regions-for-plan": "No regions available for the selected plan.",
                "no-bundles-for-plan": "No bundles available for the selected plan.",
                "save-changes": "Save changes",
                "subscription-updated": "Subscription updated",
                "modify-failed": "Failed to update subscription",
                "modify-load-failed": "Failed to load plans and configurables",
                "period-end": "Period end",
                "scheduled-cancel": "Scheduled cancel",
                "subscription-detail-description": "Subscription details, plan configuration, and identifiers.",
                "subscription-not-found": "Subscription not found",
                "scheduled-cancel-banner": "This subscription is scheduled to cancel on {date}.",
                "plan-config": "Plan configuration",
                "region": "Region",
                "size": "Size",
                "provider": "Provider",
                "bundles": "Bundles",
                "features": "Features",
                "identifiers": "Identifiers",
                "subscription-id": "Subscription ID",
                "plan-id": "Plan ID",
                "deployment-id": "Deployment ID",
                "payment-method-id": "Payment method ID",
                "period-start": "Period start",
                "updated": "Updated",
                "workspace": "Workspace",
                "copied": "Copied!",
                "operations": "Operations",
                "operations-description": "Administrative operations and maintenance tools.",
                "operation-deployment-migration": "Deployment Migration",
                "operation-deployment-migration-description": "Transfer a customer's subscription and payment method to a new deployment.",
                "migration-old-id": "Old Deployment ID",
                "migration-new-id": "New Deployment ID",
                "migration-old-placeholder": "Customer's existing deployment ID",
                "migration-new-placeholder": "Admin's new deployment ID",
                "migration-preview-btn": "Preview",
                "migration-execute-btn": "Execute Migration",
                "migration-executing": "Executing...",
                "migration-success": "Migration completed successfully.",
                "migration-error": "Migration failed: {message}",
                "migration-preview-title": "Migration Preview",
                "migration-preview-old": "Will be archived",
                "migration-preview-new": "Will receive subscription",
                "migration-confirm-hint": "This action is irreversible. The old deployment will be archived and its subscription transferred to the new deployment.",
                "migration-fetch-error": "Failed to fetch deployment details. Check the IDs and try again.",
                "migration-id-required": "Both deployment IDs are required.",
                "migration-step-transfer": "Transfer deployment to customer workspace",
                "migration-step-subscription": "Update customer subscription: link to new deployment + copy plan/planConfig/planCode",
                "migration-step-subscription-plan": "Update customer subscription: link to new deployment + copy plan/planConfig/planCode",
                "migration-step-archive-admin-sub": "Archive admin subscription",
                "migration-step-archive-old": "Archive old deployment",
                "migration-step-revert-transfer": "Restore deployment to admin workspace",
                "migration-step-revert-subscription": "Restore customer subscription: deployment link + plan/planConfig/planCode",
                "migration-step-revert-subscription-plan": "Restore customer subscription: deployment link + plan/planConfig/planCode",
                "migration-step-revert-admin-sub": "Restore admin subscription status",
                "migration-step-revert-old": "Restore old deployment status",
                "migration-revert-btn": "Revert Migration",
                "migration-reverting": "Reverting...",
                "migration-reverted": "Migration reverted successfully.",
                "migration-new-btn": "Start New Migration",
                "migration-label": "Migration Label",
                "migration-label-placeholder": "e.g. Customer X upgrade",
                "migration-history-title": "Past Migrations",
                "migration-history-empty": "No migrations yet.",
                "migration-delete-btn": "Delete",
                "operation-domain-transfer": "Domain Transfer",
                "operation-domain-transfer-description": "Copy the domain configuration from one deployment to another.",
                "operation-set-server-url": "Set Server URL",
                "operation-set-server-url-description": "Update the default domain in the database and send a SetServerUrl command to the Countly server.",
                "set-server-url-deployment": "Deployment",
                "set-server-url-deployment-placeholder": "Search by deployment ID",
                "set-server-url-domain": "New Domain",
                "set-server-url-domain-placeholder": "e.g. prefix-xxxx.mycountly.com",
                "set-server-url-btn": "Update & Send Command",
                "set-server-url-success": "Domain updated and SetServerUrl command sent successfully.",
                "set-server-url-new-btn": "Run Again",
                "domain-transfer-source-id": "Source Deployment ID",
                "domain-transfer-target-id": "Target Deployment ID",
                "domain-transfer-source-placeholder": "Search by deployment ID",
                "domain-transfer-target-placeholder": "Search by deployment ID",
                "domain-transfer-execute-btn": "Transfer Domain",
                "domain-transfer-executing": "Transferring…",
                "domain-transfer-success": "Domain transferred successfully.",
                "domain-transfer-error": "Transfer failed: {message}",
                "domain-transfer-label": "Label",
                "domain-transfer-label-placeholder": "e.g. production domain sync",
                "domain-transfer-reverting": "Reverting…",
                "domain-transfer-reverted": "Domain transfer has been reverted.",
                "domain-transfer-revert-btn": "Revert",
                "domain-transfer-new-btn": "New Transfer",
                "domain-transfer-history-title": "Past Transfers",
                "domain-transfer-history-empty": "No transfers yet.",
                "migration-transfer-domain": "Also transfer domain from old deployment",
                "operation-retire-free-servers": "Retire Free Servers",
                "operation-retire-free-servers-description": "Find all free (non-admin-created) deployments and set their status to retired.",
                "retire-free-servers-find-btn": "Find Candidates",
                "retire-free-servers-start-btn": "Retire All",
                "retire-free-servers-empty": "No eligible free servers found.",
                "retire-free-servers-found": "{count} server(s) found. Click \"Retire All\" to proceed.",
                "retire-free-servers-done": "Completed. {count} server(s) retired.",
                "operation-enable-plugin": "Enable Plugin",
                "operation-enable-plugin-description": "Find running deployments missing a given plugin (based on the last enablePlugin command sent to each) and send the command to enable it, one by one.",
                "enable-plugin-code-placeholder": "Plugin code (e.g. sdk)",
                "enable-plugin-find-btn": "Find Candidates",
                "enable-plugin-start-btn": "Enable For All",
                "enable-plugin-empty": "No deployments missing this plugin.",
                "enable-plugin-done": "Completed. {count} deployment(s) updated.",
                "operation-check-plugin-status": "Check Plugin Status",
                "operation-check-plugin-status-description": "Check whether a plugin has ever been enabled on a single deployment (based on its enablePlugin command history), and activate it if not.",
                "check-plugin-status-btn": "Check Status",
                "check-plugin-status-activate-btn": "Activate",
                "check-plugin-status-active": "Plugin \"{plugin}\" is active on this deployment.",
                "check-plugin-status-inactive": "Plugin \"{plugin}\" is not active on this deployment.",
                "check-plugin-status-activated": "Activation command sent.",
                "operation-unlock-users": "Unlock Users",
                "operation-unlock-users-description": "Send an UnlockUsers command to a Countly server to re-enable user logins.",
                "unlock-users-deployment": "Deployment",
                "unlock-users-deployment-placeholder": "Search by deployment ID",
                "unlock-users-btn": "Send Unlock Command",
                "unlock-users-success": "UnlockUsers command sent successfully.",
                "unlock-users-new-btn": "Run Again",
                "operation-send-deployment-creation-command": "Send Command Manifest",
                "operation-send-deployment-creation-command-description": "Re-derive the enable_initially plugin list from the subscription's current plan/bundles and send an EnablePlugin command to the Countly server.",
                "send-deployment-creation-command-deployment": "Deployment",
                "send-deployment-creation-command-deployment-placeholder": "Search by deployment ID",
                "send-deployment-creation-command-btn": "Send Command",
                "send-deployment-creation-command-success": "EnablePlugin command sent successfully.",
                "send-deployment-creation-command-plugins-label": "Plugins enabled:",
                "send-deployment-creation-command-new-btn": "Run Again",
                "send-deployment-creation-command-preview-title": "Command Preview",
                "send-deployment-creation-command-preview-loading": "Loading preview…",
                "send-deployment-creation-command-preview-error": "Failed to load preview.",
                "send-deployment-creation-command-preview-empty": "No plugins would be enabled by this command.",
                "operation-deployment-features": "Manage Deployment Features",
                "operation-deployment-features-description": "View a deployment's features/plugins and send an EnableFeature or DisableFeature command directly to the Countly server.",
                "deployment-features-deployment": "Deployment",
                "deployment-features-deployment-placeholder": "Search by deployment ID",
                "deployment-features-in-plan": "In plan",
                "deployment-features-not-in-plan": "Not in plan",
                "deployment-features-enable-btn": "Enable",
                "deployment-features-disable-btn": "Disable",
                "operation-unlock-server": "Unlock Server",
                "operation-unlock-server-description": "Send a LockServer command with false to unlock a server that was locked (e.g. due to MAU overage).",
                "unlock-server-deployment": "Deployment",
                "unlock-server-deployment-placeholder": "Search by deployment ID",
                "unlock-server-btn": "Send Unlock Server Command",
                "unlock-server-success": "LockServer (unlock) command sent successfully.",
                "unlock-server-new-btn": "Run Again",
                "operation-sync-subscription-from-paddle": "Sync Subscription from Paddle",
                "operation-sync-subscription-from-paddle-description": "Compare the deployment's subscription with the live Paddle subscription and sync the plan, size, resource limits, and draft to match Paddle's data. The billing term and used MAU are left untouched.",
                "sync-subscription-from-paddle-deployment": "Deployment",
                "sync-subscription-from-paddle-deployment-placeholder": "Search by deployment ID",
                "sync-subscription-from-paddle-preview-title": "Comparison",
                "sync-subscription-from-paddle-preview-loading": "Loading preview…",
                "sync-subscription-from-paddle-preview-error": "Failed to load preview.",
                "sync-subscription-from-paddle-column-current": "Current (DB)",
                "sync-subscription-from-paddle-column-paddle": "Paddle",
                "sync-subscription-from-paddle-row-plan": "Plan",
                "sync-subscription-from-paddle-row-size": "Size",
                "sync-subscription-from-paddle-items-title": "Paddle Line Items",
                "sync-subscription-from-paddle-product-id": "Product ID",
                "sync-subscription-from-paddle-price-id": "Price ID",
                "operation-view-paddle-items": "View Paddle Items",
                "operation-view-paddle-items-description": "List everything purchased for a deployment's Paddle subscription, with each item's Product/Price ID and whether it's recognized in our system.",
                "view-paddle-items-deployment": "Deployment",
                "view-paddle-items-deployment-placeholder": "Search by deployment ID",
                "view-paddle-items-empty": "No items found on this deployment's Paddle subscription.",
                "sync-subscription-from-paddle-already-in-sync": "Already in sync — no changes needed.",
                "sync-subscription-from-paddle-btn": "Sync from Paddle",
                "sync-subscription-from-paddle-success": "Subscription synced: {plan} / {size}.",
                "sync-subscription-from-paddle-new-btn": "Run Again",
                "operation-refresh-countly-server-secret": "Refresh Countly Server Secret",
                "operation-refresh-countly-server-secret-description": "Force-regenerate a deployment's Countly server SSO secret and push it to the target server, fixing broken Sign in via Flex links (e.g. after a migration).",
                "refresh-countly-server-secret-deployment": "Deployment",
                "refresh-countly-server-secret-deployment-placeholder": "Search by deployment ID",
                "refresh-countly-server-secret-btn": "Refresh Secret",
                "refresh-countly-server-secret-success": "Countly server secret refreshed successfully.",
                "refresh-countly-server-secret-new-btn": "Run Again",
                "operation-orphaned-subscriptions": "Orphaned Subscriptions",
                "operation-orphaned-subscriptions-description": "Find Paddle subscriptions left behind by a workspace deletion (servers torn down — via account delete, admin delete, or workspace delete — but the Paddle subscription never canceled). Verify each suspect against Paddle, then cancel it manually in the Paddle dashboard.",
                "orphaned-subs-find-btn": "Find Candidates",
                "orphaned-subs-suspects-only": "Show suspects only",
                "orphaned-subs-summary": "{total} deleted-workspace subscription(s) found, {suspects} suspected leak(s).",
                "orphaned-subs-empty": "No matching subscriptions found.",
                "orphaned-subs-col-email": "Deleted user",
                "orphaned-subs-col-deleted-at": "Deleted at",
                "orphaned-subs-col-paddle-id": "Paddle subscription",
                "orphaned-subs-col-local": "Local status",
                "orphaned-subs-col-paddle": "Paddle status",
                "orphaned-subs-check-btn": "Check Paddle",
                "orphaned-subs-check-error": "Check failed",
                "orphaned-subs-resolved": "Resolved",
                "orphaned-subs-copy": "Copy Paddle subscription ID",
                "operation-sync-mau-term": "Sync MAU Term",
                "operation-sync-mau-term-description": "Push the subscription's current MAU tracking window (resource.term) to the Countly server via a SetMauTerm command.",
                "sync-mau-term-deployment": "Deployment",
                "sync-mau-term-deployment-placeholder": "Search by deployment ID",
                "sync-mau-term-btn": "Sync MAU Term",
                "sync-mau-term-success": "MAU term synced successfully.",
                "sync-mau-term-starts-at-label": "Starts at:",
                "sync-mau-term-ends-at-label": "Ends at:",
                "sync-mau-term-new-btn": "Run Again"
            },
            "draft": {
                "title": "Your Secure Countly Server in Region awaits",
                "subtitle": "Complete Your server setup and start privacy-led analytics",
                "go-to-draft": "discard draft",
                "delete-draft": "continue where you left off"
            },
            "empty": {
                "title": "No servers yet",
                "description": "Create your first server to start collecting analytics data from your apps and websites.",
                "cta": "Create server",
                "how-it-works": "How it works",
                "step1": {
                    "title": "Create a server",
                    "description": "Choose a region and tier based on your expected traffic"
                },
                "step2": {
                    "title": "Install the SDK",
                    "description": "Add the Countly SDK to your web or mobile application"
                },
                "step3": {
                    "title": "Analyze your data",
                    "description": "View real-time analytics, crashes, and user behavior"
                }
            },
            "settings": {
                "general": "General",
                "profile": "Profile",
                "password": "Password",
                "update-password": "Update password",
                "two-factor-authentication": "Two-factor authentication",
                "save-changes": "Save changes",
                "delete-account": "Delete account",
                "delete-workspace": "Delete workspace"
            }
        },
        "2fa": {
            "title": "Two-Factor Authentication",
            "please-enter-authcode": "Please enter the code from your authenticator app"
        },
        "menu": {
            "profile-settings": "Profile Settings",
            "account-settings": "Account Settings",
            "workspace-settings": "Workspace Settings",
            "team": "Team",
            "billing": "Billing",
            "logout": "Logout"
        },
        "deployments": {
            "table-description": "All your Countly servers, their domains, sizes, and utilization are listed in this section",
            "empty-table-description": "Get started by creating a server",
            "domain-configuration-updated": "Domain configuration updated",
            "domain-could-not-be-verified": "Domain could not be verified. Check that your DNS A record points to the IP address shown and try again."
        },
        "management": {
            "company-table-description": "Manage your workspace settings from this section",
            "project-table-description": "Create projects to organize your servers and manage them from this section",
            "workspace-viewer": "Workspace Viewer",
            "workspace-admin": "Workspace Admin",
            "billing-table-description": "Create and manage billings to keep track of your payments",
            "team-table-description": "Invite new team members to your workspace and manage them from this section",
            "billing": {
                "servers": {
                    "empty": "...hmm, seems it's empty here"
                },
                "servers-empty": {
                    "instructions": "After server setup, you'll see billing details and history here."
                },
                "header": "Update billing information and view billing history and invoices.",
                "all-servers": "All servers",
                "subscription_created": "Subscription created",
                "subscription_updated": "Subscription updated",
                "payment-method-changed": "Payment method changed",
                "invoice": "Invoice"
            },
            "deployment": {
                "update-ip-dialog": "Insert the new IP address",
                "update-ip-dialog-title": "Are you sure you want to update IP?"
            }
        },
        "account": {
            "settings-table-description": "This is where you can view and edit your account settings"
        },
        "authentication-settings-table-description": "This is where you can view and edit authentication settings",
        "data": {
            "settings-table-description": "This is where you can remove all of your user data"
        },
        "deployment": {
            "settings-unlock-user-form-description": "Enter the email address of the user you'd like to unlock the account of",
            "provisioned": "Deployment provisioned successfully.",
            "deleted": "Deployment deletion scheduled."
        },
        "company": {
            "created": "workspace created"
        },
        "plan": {
            "created": "plan created",
            "updated": "plan updated"
        },
        "plan-group": {
            "created": "plan group created"
        },
        "project": {
            "created": "project created",
            "deleted": "project deleted"
        },
        "admin": {
            "task": {
                "retry": "Retry"
            }
        },
        "server-creation": {
            "choose-plan-next": "Continue to hosting region",
            "choose-region-next": "Continue to core features",
            "choose-region-next-prelogin": "Create an account",
            "core-features-next": "Continue to add-ons selection",
            "choose-add-ons-next": "Continue to extras selection",
            "choose-extras-next": "Continue",
            "back-to-server-configuration": "Back to server configuration",
            "trial-badge": "Included in 14-day trial",
            "summary-due-today": "Due today",
            "summary-total-due": "Total due",
            "summary-after-trial": "After 14-day trial: {price}/{period}",
            "summary-after-trial-included": "After 14-day trial: included",
            "summary-plus-taxes": "+ Applicable taxes",
            "per-month-plus-taxes": "per month (+ applicable taxes)"
        }
    },
    "This usually takes a few minutes": {
        "": ""
    },
    "mycouny": {
        "dashboard": {
            "deployments": {
                "zombie-days-ago": "days ago"
            }
        }
    },
    "emails": {
        "greeting": {
            "header": "Welcome to myCountly {0}!"
        }
    }
}
